<script lang="ts">
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	import { CURRENCIES } from 'src/constants';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { user_settings } from 'src/stores/account/user';
	import { AlertV2, ButtonV2, SelectV2, Stack, Text } from '@Shelly/shelly-design-system';

	const currencyOptions = CURRENCIES.map((e) => e.CurrencyCode);
	let selected = $user_settings.currency || '';
	let initialSelected = selected;

	$: hasChanged = selected !== initialSelected;
	$: invalidCurrency =
		selected && !currencyOptions.some((code) => code === selected.toUpperCase());

	const saveCurrency = async () => {
		const res = await postReq(
			'/v2/users/power-prices/currency',
			{ currency: selected },
			undefined,
			undefined,
			undefined,
			true,
		);
		const successCheck = res?.hasOwnProperty('isok') ? res?.isok : !res?.error;
		if (successCheck) {
			user_settings.set({ ...$user_settings, currency: selected });
			initialSelected = selected;
		}
		onSettingsResponse(res, null, {
			success: $format('currency_set', {
				default: 'Currency set successfully.',
			}),
		});
	};
</script>

{#if invalidCurrency}
	<AlertV2
		backgroundColor="color-00"
		class="mb-s"
		heading={$format('currency_re_add', {
			default:
				'Your current currency is not supported. Please select a currency from the listed options.',
		})}
	/>
{/if}

<Stack
	direction="column"
	directionMobile="row"
	align="between"
	alignMobile="none"
	gap="m"
	class="align-items-center"
>
	<div>
		<Text class="mb-s" styleType="body">
			{$format('label_currency', { default: 'Currency' })}
		</Text>
		<SelectV2
			backgroundColor="color-black"
			aria-label={$format('label_currency', { default: 'Currency' })}
			bind:value={selected}
			width="full"
			icon="fas fa-money-bill-wave"
			options={currencyOptions}
			id="select-energy-currency"
			class="mr-s"
		/>
	</div>

	<ButtonV2 size="m" variant="secondary" disabled={!selected || !hasChanged} on:click={saveCurrency}>
		{$format('button_save')}
	</ButtonV2>
</Stack>
